var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('DefaultHeader'),_c('router-view',{key:_vm.$route.fullPath}),_c('Footer'),_c('app-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }